export default {
  storeValueMaxWidth: '5rem',
};
